<template>
	<div class="mydata">
		<div class="title">
			<div id="notice">
				<h5>用户档案&nbsp;&nbsp;说明:</h5><br>
				<span>1、新增用户至少填写一个电话或者邮箱</span><br>
				<span>2、只有管理员才能删除用户</span><br>
				<span>3、新增用户默认密码六个一,初始员工状态为入职(必须现在类别中设置好才行)</span><br>
				<span>4、查询关键字:账号、姓名、电话1</span><br>
				<span>5、重置用户密码为123456</span><br>
				<span class="red">6、修改已注销人员任意信息，改账号恢复正常</span><br>
				<span></span><br>
			</div>
		</div>
		<div class="content_edit">

			<pre-button @button-event="select_method" :pre_control="'control_user'" />
			<div class="content_btn">
				<div class="content_btn_item">
					<!-- <button class="pre_btn_ok" @click="excelup()">
						导入界面
					</button> -->
					<button class="pre_btn_ok" @click="fun_pwd_init">重置用户密码</button>
					<button class="pre_btn_ok" @click="fun_pwd_change">修改用户密码</button>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>
		<div class="content_edit">
			<div class="content_edit_item">
				<label>账号:</label>
				<input type="text" placeholder="请输入账号" v-model="t_userno" @keyup.enter="refresh_data" />&nbsp;&nbsp;
				<label>姓名:</label>
				<input type="text" placeholder="请输入姓名" v-model="t_username" @keyup.enter="refresh_data" />&nbsp;&nbsp;
				<label>电话:</label>
				<input type="text" placeholder="请输入电话" v-model="t_phone" @keyup.enter="refresh_data" />&nbsp;&nbsp;

				<label>角色:</label><input class="short0" type="text" v-model="t_rolename" readonly="readonly"
					style="background-color: lightgray;" />
				<pre-select class="short0" @selectFunc="selectFunc" v-bind:searchList="comtype"
					:selectValue="sel_comtypename" />

			</div>
		</div>
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr>
					<th>序号</th>
					<th>系统编号</th>
					<th>用户名称</th>
					<th>角色</th>
					<th>部门</th>
					<th>状态</th>
					<th class="long1">电话</th>
					<th>启用标识</th>
					<!--  <th class="temp_email">邮箱</th>
          <th>qq</th>
          <th>微信</th>
          <th>地址</th> -->
					<th class="long1">部门负责人</th>
					<th class="temp_oper">操作</th>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'tr' + user.item.row_num" @click="sel_row(user.item)">
					<td>{{ user.item.row_num }}</td>
					<td>{{ user.item.u_no }}</td>
					<td>{{ user.item.u_name }}</td>
					<td>{{ user.item.r_name }}</td>
					<td>{{ user.item.department }}</td>
					<td>{{ user.item.user_flag }}</td>
					<td class="long1">{{ user.item.phone }}</td>
					<td>{{ user.item.flag }}</td>
					<!-- <td class="temp_email">{{ user.item.email }}</td>
          <td>{{ user.item.qq }}</td>
          <td>{{ user.item.weixin }}</td>
          <td>{{ user.item.address }}</td> -->
					<td class="long1">{{ user.item.leader_name }}</td>
					<td class="temp_oper">
						<img src="../../assets/image/edit.png" @click="fun_upd(user.item)" />
						<img src="../../assets/image/delete.png" @click="fun_del(user.item.id)" />
					</td>
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">
				<div class="pop_edit">
					<div class="pop_edit_item">
						<h3 class="cen">用户信息编辑</h3>
					</div>
					<div class="pop_edit_item">
						<label>编号:</label><input type="text" v-model="t_userno" />
					</div>
					<div class="pop_edit_item"><label>姓名:</label><input type="text" v-model="t_username" /></div>
					<div class="pop_edit_item">
						<label>角色:</label><input type="text" v-model="t_rolename" readonly="readonly"
							style="background-color: lightgray;" />
						<pre-select class="short0" @selectFunc="selectFunc" v-bind:searchList="comtype"
							:selectValue="sel_comtypename" />
					</div>
					<div class="pop_edit_item">
						<label>部门:</label><input type="text" v-model="sel_ok_depname" readonly="readonly"
							style="background-color: lightgray;" />
						<pre-select class="short0" @selectFunc="sel_department" v-bind:searchList="list_department"
							:selectValue="sel_depname" />
					</div>
					<div class="pop_edit_item">
						<label>负责人:</label>
						<input type="text" v-model="sel_leader_name" @change="fun_change" />
						<pre-select class="short0" @selectFunc="fun_sel_leader" v-bind:searchList="list_leader"
							:selectValue="sel_leader" />
					</div>
					<div class="pop_edit_item"><label>电话:</label><input type="text" v-model="t_phone" /></div>
					<!-- <div class="pop_edit_item"><label>邮箱:</label><input type="text" v-model="t_email" /></div>
					<div class="pop_edit_item"><label>qq:</label><input type="text" v-model="t_qq" /></div>
					<div class="pop_edit_item"><label>微信:</label><input type="text" v-model="t_weixin" /></div>
					<div class="pop_edit_item"><label>地址:</label><input type="text" v-model="t_address" /></div> -->
					<div class="pop_edit_item cen"><button @click="fun_save()">{{t_action_name}}</button></div>
				</div>
			</template>
		</pre-table>
		<per-message-text @msg-event="refresh_msgdata" :message_data="msgtext_obj" />

		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm" :api_url="api_url"
			:api_action="upd_action" />

		<!-- 通用导出excel -->
		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>
	</div>
</template>

<script>
	import api from '@/utils/type.js'
	import {
		GetShort
	} from "@/utils/localstore.js";
	import {
		Method_DataByPage,
		Method_EasySelect,
		Method_EasyUpdate,
		Method_UserAction
	} from '@/utils/loadhttpdata.js';

	// const url = require("@/assets/verify/images/1.jpg");
	export default {
		components: {
			"pre-button": () => import("../per_old/pre_btn_control.vue"),
			"pre-table": () => import("../per_old/pre_table_nokey.vue"),
			'pre-select': () => import("../per_old/pre_select_one.vue"),
			'per-message-text': () => import("../per_old/pre_message_text.vue"),
			"pre-button": () => import("../per_old/pre_btn_control.vue"),
			'per-exceldown': () => import("../per_old/pre_excel_down.vue"),
			'per-excelup': () => import("../per_old/pre_excel_up_new.vue")
		},
		data() {
			return {
				show_note: false,
				load_url: '',
				load_json: '',
				upd_json: '',
				upd_upfile_name: '',
				t_action_name: '',
				t_action: '',
				t_rowid: '',
				t_userno: '',
				t_username: '',
				t_rolename: '',
				t_roleid: '',
				t_phone: '',
				t_email: '',
				t_qq: '',
				t_weixin: '',
				t_address: '',
				t_sysdate: '',
				nowpage: '1',
				comtype: [],
				sel_comtypename: {},
				sel_ok_value: '',
				list_department: [],
				sel_depname: {},

				list_leader: [],
				list_leader_bak: [],
				sel_leader: {},
				sel_leader_name: '',
				sel_leader_id: '',


				sel_ok_departid: '',
				sel_ok_depname: '',
				t_ok_departid: '',
				t_ok_depname: '',
				key_word: '',
				msgtext_obj: {},
				show_tan_up: '',
				post_item: '',
				sel_item: {},

				// excel
				show_excel: false,
				postjson1: {},

				sel_action: '',
				api_url: '',
				upd_action: '',
				parm: [], //明细参数构造
				parm_th: []

			};
		},
		created: function() {
			this.loaddata();
			this.loadRoleName();
			this.loadDepartment();
			this.loadUser();
		},
		methods: {
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			loaddata: function() {
				console.log('===========123');
				this.load_url = api.http_method;
				this.load_json = Method_DataByPage('data_user_data', this.nowpage, '', '');

				this.sel_action = 'data_user_data';
				this.api_url = api.http_method;
				this.upd_action = 'user_data';
				this.parm = [
					{
						"name": "系统编号",
						"val": "",
						"key": "user_no",
						"type": "text",
						"p":"1"
					},
					{
						"name": "用户姓名",
						"val": "",
						"key": "user_name",
						"type": "text",
						"p":"1"
					},
					{
						"name": "角色",
						"val": "",
						"key": "r_name",
						"type": "text",
						"p":"1"
					},
					{
						"name": "部门",
						"val": "",
						"key": "d_name",
						"type": "text",
						"p":"1"
					},
					{
						"name": "电话",
						"val": "",
						"key": "phone",
						"type": "text",
						"p":"1"
					},
					{
						"name": "邮箱",
						"val": "",
						"key": "email",
						"type": "text",
						"p":"1"
					},
					{
						"name": "QQ",
						"val": "",
						"key": "qq",
						"type": "text",
						"p":"1"
					},
					{
						"name": "微信",
						"val": "",
						"key": "wx",
						"type": "text",
						"p":"1"
					},
					{
						"name": "地址",
						"val": "",
						"key": "addr",
						"type": "text",
						"p":"1"
					},
					{
						"name": "身份证号码",
						"val": "",
						"key": "u_card",
						"type": "text",
						"p":"1"
					}
				];
				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "系统编号"
					},
					{
						"name": "用户姓名"
					},
					{
						"name": "角色"
					},
					{
						"name": "部门"
					},
					{
						"name": "状态"
					},
					{
						"name": "电话"
					},
					{
						"name": "启用标识"
					},
					{
						"name": "部门负责人"
					},
					// {
					//   "name": "邮箱"
					// },
					// {
					//   "name": "QQ"
					// },
					// {
					//   "name": "微信"
					// },
					// {
					//   "name": "地址"
					// },
					{
						"name": "更新时间"
					}
				]
			},
			select_method: function(type) {
				console.log(type);
				if (type != 'add' && type != 'sel' && Number(this.row_id) == 0) {
					this.$message.error('请先选择要编辑的数据!');
					return;
				}
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						// 不能在方法里传  this.变量
						this.fun_add();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_add();
						break;
					case 'upd':
						this.fun_upd();
						break;
					case 'del':
						this.fun_del();
						break;
					case 'sel':
						this.refresh_data();
						break;
					case 'sub':
						this.fun_sub();
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl':
						this.build_exceldata();
						break;
					case 'fileup':
						this.fun_fileup();
						break;
					case 'filelook':
						this.fun_filelook();
						break;
					case 'filedel':
						this.fun_filedel();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			refresh_data: function(page, keyword, type) {
				let r = (Math.random() + '').substring(0, 4);
				if (Number(page) > 0) {
					this.nowpage = page;
				}

				console.log('角色');

				this.load_json = Method_DataByPage('data_user_data', page, this.t_userno, this.t_username, this
					.t_phone, this
					.t_roleid, '',
					r);
			},
			fun_add: function() {
				// 展示新增位置
				this.data_clear();
				this.t_action_name = '新增用户档案';
				this.t_action = 'add';
				this.t_userno = '系统随机生成'
				this.$refs.file_table.showpop();
			},
			fun_del: function(id) {
				var con = confirm('您确定要删除当前数据! id=' + this.t_rowid);
				if (con == true) {
					this.upd_json = Method_UserAction('data_del_user', this.t_rowid, GetShort('userno'));
				}
			},
			fun_upd: function(item) {
				this.data_clear();
				this.t_action_name = '修改用户档案';
				this.t_action = 'upd';
				if (item == undefined) {
					item = this.sel_item;
				}

				this.t_rowid = item.id;
				this.t_userno = item.u_no;
				this.t_username = item.u_name;
				this.t_rolename = item.r_name;
				this.t_ok_depname = item.department;
				this.sel_ok_depname = item.department;
				this.t_phone = item.phone;
				this.t_weixin = item.weixin;
				this.t_address = item.address;
				this.t_email = item.email;
				this.t_qq = item.qq;
				this.t_sysdate = item.sys_date;

				this.user_flag = item.user_flag;


				this.$refs.file_table.showpop();
			},
			data_clear: function() {
				this.t_userno = '';
				this.t_username = '';
				this.t_roleid = '';
				this.t_phone = '';
				this.t_weixin = '';
				this.t_address = '';
				this.t_email = '';
				this.t_qq = '';

				// this.sel_comtypeID = '';
				// this.sel_ok_value = '';
				// this.t_rolename = '';
				// this.t_roleid = '';

				// this.sel_ok_depname = '';
				// this.sel_ok_departid = '';
				// this.t_ok_depname = '';
				// this.t_ok_departid = '';
				// this.sel_comtypename={};
				// this.sel_depname={};

			},
			fun_save: function() {
				if (Number(this.t_roleid) == 0 && this.t_rolename != '') {
					this.selcomtype(this.t_rolename);
				}
				if (Number(this.t_ok_departid) == 0 && this.t_ok_depname != '') {
					this.sel_department(this.t_ok_depname);
				}
				
				// console.log('电话='+this.t_phone);

				if (this.t_action == 'add') {

					if (Number(this.t_roleid) > 0) {
						this.upd_json = Method_UserAction('data_add_user', '', this.t_userno, this.t_username, this
							.t_roleid,
							this.t_phone, this.t_email, this.t_weixin, this.t_qq, this.t_address, '', this
							.t_ok_departid, this
							.sel_leader_id);
					} else {

						this.$message({
							message: '新增用户必须赋予角色',
							type: 'error'
						});
					}
				} else if (this.t_action == 'upd') {
					console.log('部门id=' + this.sel_ok_departid);
					this.upd_json = Method_UserAction('data_update_user', this.t_rowid, this.t_userno, this.t_username,
						this.t_roleid,this.t_phone, this.t_email, this.t_weixin, this.t_qq, this.t_address, this.t_sysdate, 
						this.sel_ok_departid, this.sel_leader_id
					);
				} else {
					this.$message({
						message: '未知操作 action=' + this.t_action,
						type: 'error'
					});
				}
			},
			selectFunc: function(parm) {
				// console.log('选择结果='+parm);
				this.selcomtype(parm);
			},
			loadRoleName: function() {
				this.$post(
					api.http_method, Method_EasySelect('data_role')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {
						this.comtype = res.data.data;
					}
				});
			},
			loadDepartment: function() {
				this.$post(
					api.http_method, Method_EasySelect('data_dep')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {
						this.list_department = res.data.data;
					}
				});
			},
			loadUser: function() {
				this.$post(
					api.http_method, Method_EasySelect('data_alluser', '')
				).then(res => {

					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {
						this.list_leader = [];
						this.list_leader = res.data.data;
						this.list_leader_bak = res.data.data;
					}
				});
			},
			fun_change: function() {


				let is_back = false;
				// 模糊查询
				if (typeof(this.sel_leader_name) != "undefined" && this.sel_leader_name != '') {

					// 模糊查询
					this.list_leader = [];
					for (let j = 0; j < this.list_leader_bak.length; j++) {
						if (this.list_leader_bak[j].val.indexOf(this.sel_leader_name) >= 0) {
							this.list_leader.push(this.list_leader_bak[j]);
						}
					}


					if (this.list_leader.length == 0) {
						for (let j = 0; j < this.list_leader_bak.length; j++) {
							if (this.list_leader_bak[j].val == this.sel_leader_name) {
								this.sel_leader_id = this.list_leader_bak[j].val;
								this.sel_leader_name = this.list_leader_bak[j].val;

								is_back = true;
								break;
							}
						}
						this.list_leader = this.list_leader_bak;


					}

				} else {
					this.list_leader = [];
					this.list_leader = this.list_leader_bak;
				}

			},
			fun_sel_leader: function(value) {
				for (var i = 0; i < this.list_leader.length; i++) {
					if (this.list_leader[i].id == value || this.list_leader[i].val == value) {
						this.sel_leader_id = this.list_leader[i].id;
						this.sel_leader_name = this.list_leader[i].val;
						break;
					}
				}
			},
			selcomtype: function(value) {

				for (var i = 0; i < this.comtype.length; i++) {
					if (this.comtype[i].id == value || this.comtype[i].val == value) {
						this.sel_comtypeID = this.comtype[i].id;
						this.sel_ok_value = this.comtype[i].val;
						this.t_rolename = this.comtype[i].val;
						this.t_roleid = this.comtype[i].id;
						break;
					}
				}

				// console.log('选择发布类型='+this.sel_comtypeID);

			},
			sel_department: function(item) {

				this.sel_departmentid(item);
			},
			sel_departmentid: function(value) {
				for (var i = 0; i < this.list_department.length; i++) {
					if (this.list_department[i].id == value || this.list_department[i].val == value) {
						this.sel_ok_depname = this.list_department[i].val;
						this.sel_ok_departid = this.list_department[i].id;
						this.t_ok_depname = this.list_department[i].val;
						this.t_ok_departid = this.list_department[i].id;

						break;
					}
				}

			},
			fun_pwd_init: function() {
				if (this.t_userno != '') {
					var temp = '';
					temp = '=' + this.t_userno + '\r\n昵称=' + this.t_username;
					this.msgtext_obj = {
						'showtype': '3',
						'title': '警告',
						'note': '您确定要重置用户' + temp + '信息？',
						'back_type': 'pwd_init',
						'btn1': '确定',
						'btn3': '取消'
					};
				} else {

					this.$message({
						type: 'error',
						message: '请先选择对应的用户,再执行相关操作!'

					});
				}
			},
			fun_pwd_change: function() {
				if (this.t_userno != '') {
					this.msgtext_obj = {
						'showtype': '4',
						'title': '请输入修改密码',
						'back_type': 'pwd_upd',
						'btn1': '确定',
						'btn3': '取消'
					};
				} else {

					this.$message({
						type: 'error',
						message: '请先选择对应的用户,再执行相关操作!'

					});
				}
			},
			refresh_msgdata: function(parm1, parm2, parm3) {
				// console.log(parm1+'  '+parm2+' '+parm3);

				if (parm2 == 'YES' && parm3 == 'pwd_init') {
					// console.log('重置'+this.t_userno);
					var post_data = Method_EasyUpdate('data_pwd_init', this.t_rowid, this.t_userno);
					this.EasyUpdate(post_data);
				}
				if (parm2 == 'YES' && parm3 == 'pwd_upd') {
					// console.log('修改'+this.t_userno+' pwd='+parm1);
					var post_data = Method_EasyUpdate('data_pwd_forget', this.t_rowid, this.t_userno, '', parm1);
					this.EasyUpdate(post_data);
				}
			},
			EasyUpdate: function(postdata) {
				this.fullloading = true;
				this.$post(
					api.http_method,
					postdata,
				).then(res => {
					this.fullloading = false;
					try {
						// console.log(res.data);
						res = JSON.parse(res);
						console.log(res.data);
						if (res.data.status == 1) {

							this.$message({
								type: 'success',
								message: res.data.msg
							});
							// this.sel_row(item);
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg
							});
						}
					} catch (ex) {

						this.$message({
							type: 'error',
							message: "查询失败" + ex
						});
					}
				});
			},
			sel_row: function(parm) {
				// console.log(parm);
				this.t_rowid = parm.id;
				this.t_userno = parm.u_no;
				this.t_username = parm.u_name;

				this.sel_item = {};
				this.sel_item = parm;

				this.$refs.file_table.setCurrentRow(parm, 'tr');
			},
			fun_changflag: function() {
				if (Number(this.t_rowid) == 0) {
					this.$message.error('错了哦,请先点击要改变状态的员工信息!');
					return;
				}
				this.post_item = JSON.stringify({
					"id": this.t_rowid,
					"name": this.t_username,
					"flag": this.user_flag
				});
				this.show_tan_up = Math.random() + '';
			},
			// 导入导出
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Method_DataByPage(this.sel_action, this.nowpage, this.t_userno, this.t_username,
							this.t_phone,
							this.t_roleid, '')

					});

					this.show_excel = true;
				}
			},
			// 弹窗相关操作
			fun_filesel: function() {

			},
			fun_fileup: function() {

			},
			fun_filelook: function() {

			},
			fun_filedel: function() {

			}
		}

	};
</script>
<style scoped>
	.mydata {
		width: auto;
	}

	.temp_email {
		min-width: 180px !important;
		max-width: 180px !important;
		text-align: left !important;
	}

	.temp_oper {
		min-width: 200px !important;
		max-width: 200px !important;
		text-align: center !important;
	}

	.temp_oper>img {
		width: 18px;
		height: 18px;
		border: 0px;
		text-align: left;
		/* font-size: 16px; */
		margin-left: 5px;
		margin-right: 5px;
	}

	.pop_edit_item label {
		min-width: 72px;
		    display: inline-flex;
		    flex-direction: row;
		    justify-content: flex-end;
	}
</style>
